import React from 'react';
import Tooltip from '@/components/Tooltip';
import OpenAILogo from '@/components/icons/OpenAILogo';

// KeyStatTooltipContent helper component for tooltips
const KeyStatTooltipContent: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="w-64 p-2 text-xs font-mono">
    {children}
  </div>
);

// StatCard component to standardize the stat block appearance
const StatCard: React.FC<{
  title: string;
  value: string;
  footer: string;
  tooltipContent: React.ReactNode;
  isOpenBrain?: boolean;
}> = ({ title, value, footer, tooltipContent, isOpenBrain = false }) => (
  <Tooltip content={<KeyStatTooltipContent>{tooltipContent}</KeyStatTooltipContent>}>
    <div className={`px-4 py-2 rounded-md h-full ${isOpenBrain ? "bg-[var(--accent)] text-white" : "border border-black"} relative`}>
      {isOpenBrain && (
        <div className="absolute top-2 right-2">
          <OpenAILogo size={20} color="white" />
        </div>
      )}
      <div className={`text-[10px] uppercase mb-1 ${isOpenBrain ? "text-white" : "text-gray-500"}`}>{title}</div>
      <div className="text-2xl font-bold">{value}</div>
      <div className={`text-[10px] ${isOpenBrain ? "text-white" : "text-gray-500"}`}>{footer}</div>
    </div>
  </Tooltip>
);

const KeyMetrics2026: React.FC = () => {
  return (
    <div className="font-mono mt-8 mb-8">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
        
        {/* Global AI Title + First Stat */}
        <div className="order-10 lg:order-none">
          <StatCard 
            title="世界のAI設備投資"
            value="$1T"
            footer="稼働中の計算資源の所有コスト"
            tooltipContent={"AIインフラに対する世界全体の設備投資額。"}
          />
        </div>

        {/* Title - spans 2 columns */}
        <div className="col-span-2">
          <h2 className="text-[40px] font text-right not-italic mt-0 mb-0 font-bold font-sans tracking-tight uppercase">2026年の主要指標</h2>
          {/* <h3 className="text-xl font-bold mb-4 uppercase italic bg-[var(--accent)] text-white inline-block px-2 py-1">OPENMIND</h3> */}
        </div>

        {/* Global AI stats - row 2 */}
        <div className="order-11 lg:order-none">
          <StatCard 
            title="世界のAI電力"
            value="38GW"
            footer="ピーク電力"
            tooltipContent={"AIシステムによる世界全体のピーク電力消費量。"}
          />
        </div>
        
        {/* OpenBrain stats - row 1, columns 1-2 */}
        <div className="order-1 lg:order-none">
          <StatCard 
            title="OpenBrainの収益"
            value="$35B"
            footer="2026年 通年"
            tooltipContent={"OpenBrainの2026年の年間収益予測。"}
            isOpenBrain={true}
          />
        </div>
        
        <div className="order-2 lg:order-none">
          <StatCard 
            title="設備投資"
            value="$200B"
            footer="OpenBrainの稼働中の計算資源の所有コスト"
            tooltipContent={"OpenBrainの計算インフラに対する設備投資の総額。"}
            isOpenBrain={true}
          />
        </div>

        {/* Global AI stats - row 3 */}
        <div className="order-12 lg:order-none">
          <StatCard 
            title="米国の電力に占めるAIの割合"
            value="2.5%"
            footer="1.34TWの容量のうち33 GW"
            tooltipContent={"AIの運用に使われる米国の電力容量の割合。"}
          />
        </div>
        
        
        
        {/* OpenBrain stats - row 2, columns 1-2 */}
        <div className="order-3 lg:order-none">
          <StatCard 
            title="OpenBrainの計算資源コスト"
            value="$40B"
            footer="2026年 通年"
            tooltipContent={"OpenBrainの運用にかかる年間の計算資源コスト。"}
            isOpenBrain={true}
          />
        </div>
        
        <div className="order-4 lg:order-none">
          <StatCard 
            title="OpenBrainの必要電力"
            value="6GW"
            footer="ピーク電力"
            tooltipContent={"OpenBrainの計算インフラのピーク電力需要。"}
            isOpenBrain={true}
          />
        </div>
        
        
        
        
      </div>
    </div>
  );
};

export default KeyMetrics2026;
